/*
 * ============================================================
 * argile-video.js — contrôles vidéo (play/pause + son) réutilisables
 * ============================================================
 * Chargé PAR les sections qui l'utilisent (cf. sections/argile-hero.liquid).
 *
 * Cible `[data-argile-video-controls]` ; relie à sa <video>
 * (data-target, sinon [data-argile-video-scope], sinon parent).
 *
 * Gère aussi `[data-argile-hero-sources]` : une <video> qui porte deux URL
 * (desktop / mobile) et dont la source est choisie ici, pour ne télécharger
 * qu'un seul fichier.
 */
(function () {
  'use strict';

  /* ----------------------------------------------------------------
   * Source desktop / mobile
   * ----------------------------------------------------------------
   * La <video> est rendue SANS source : on pose la bonne ici. C'est ce qui évite
   * de télécharger les deux fichiers, mais ça veut dire que sans JS il ne reste
   * que le poster (vidéo décorative, c'est assumé).
   *
   * Le choix suit la FORME de la fenêtre, pas sa largeur : à ratio 1/1 les deux
   * formats perdent autant d'image, au-dessous le vertical gagne. Une règle en
   * largeur donnerait la vidéo verticale à un téléphone en paysage.
   */
  function sourceQuery(video) {
    return window.matchMedia(video.getAttribute('data-src-query') || '(max-aspect-ratio: 1/1)');
  }

  function applyHeroSource(video) {
    var mobile = video.getAttribute('data-src-mobile');
    var desktop = video.getAttribute('data-src-desktop');
    var url = (sourceQuery(video).matches && mobile) ? mobile : desktop;
    if (!url || video.dataset.argileSrc === url) return;

    /* Au premier passage la vidéo n'a jamais joué : on démarre. Ensuite (rotation
       d'écran, redimensionnement) on respecte l'état en cours — si le visiteur a
       mis en pause, changer de source ne relance pas la lecture. */
    var resume = !video.dataset.argileSrc || !video.paused;
    video.dataset.argileSrc = url;
    video.src = url;
    video.load();
    if (resume) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  function initHeroSources(root) {
    var scope = root || document;
    var videos = scope.querySelectorAll('video[data-argile-hero-sources]');
    if (!videos.length) return;

    videos.forEach(function (video) {
      applyHeroSource(video);
      if (video.dataset.argileSourcesWired) return;
      video.dataset.argileSourcesWired = '1';

      var mql = sourceQuery(video);
      var onChange = function () { applyHeroSource(video); };
      if (mql.addEventListener) mql.addEventListener('change', onChange);
      else if (mql.addListener) mql.addListener(onChange);
    });
  }

  function resolveVideo(ctrl) {
    var id = ctrl.getAttribute('data-target');
    if (id) {
      var el = document.getElementById(id);
      if (el) return el.tagName === 'VIDEO' ? el : el.querySelector('video');
    }
    var scope = ctrl.closest('[data-argile-video-scope]') || ctrl.parentElement;
    return scope ? scope.querySelector('video') : null;
  }

  function syncVideoControls(ctrl, video) {
    ctrl.classList.toggle('is-paused', video.paused);
    ctrl.classList.toggle('is-muted', video.muted);
    var pp = ctrl.querySelector('[data-action="playpause"]');
    var mu = ctrl.querySelector('[data-action="mute"]');
    if (pp) {
      pp.setAttribute('aria-pressed', String(!video.paused));
      pp.setAttribute('aria-label', video.paused ? (ctrl.dataset.labelPlay || 'Lire la vidéo') : (ctrl.dataset.labelPause || 'Mettre la vidéo en pause'));
    }
    if (mu) {
      mu.setAttribute('aria-pressed', String(!video.muted));
      mu.setAttribute('aria-label', video.muted ? (ctrl.dataset.labelUnmute || 'Activer le son') : (ctrl.dataset.labelMute || 'Couper le son'));
    }
  }

  function initVideoControls(root) {
    var scope = root || document;
    var ctrls = scope.querySelectorAll('[data-argile-video-controls]');
    if (!ctrls.length) return;

    ctrls.forEach(function (ctrl) {
      if (ctrl.dataset.argileWired) return;
      var video = resolveVideo(ctrl);
      if (!video) return;
      ctrl.dataset.argileWired = '1';

      var pp = ctrl.querySelector('[data-action="playpause"]');
      var mu = ctrl.querySelector('[data-action="mute"]');

      if (pp) {
        pp.addEventListener('click', function () {
          if (video.paused) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }

      if (mu) {
        mu.addEventListener('click', function () {
          video.muted = !video.muted;
          if (!video.muted && video.volume === 0) video.volume = 1;
          syncVideoControls(ctrl, video);
        });
      }

      ['play', 'pause', 'volumechange'].forEach(function (ev) {
        video.addEventListener(ev, function () { syncVideoControls(ctrl, video); });
      });

      syncVideoControls(ctrl, video);
    });
  }

  function boot(root) {
    /* La source d'abord : les contrôles lisent l'état de lecture à leur câblage. */
    initHeroSources(root);
    initVideoControls(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
